// @flow

// Effect Manager
import { fork } from 'redux-saga/effects'

// Sagas
import watchSoilJobsOperations from './operations'
import watchTableSoilJobsOperations from './tableOperations'
import { watchOperations } from 'fc-operator-sampling-jobs'
import setJobUrl from './setJobUrl'
import { uploadSeasonJobsSaga } from 'hfty-import-jobs-tool-dom'
import { watchReopenJobOperations } from 'hfty-operator-reopen-job'

// Selectors
import operations$ from '../selectors/operations'
import tableOperations$ from '../selectors/tableOperations'

export default function *main (): Generator<*, void, *> {
  yield fork(watchSoilJobsOperations)
  yield fork(watchTableSoilJobsOperations, { tableOperations$ })
  yield fork(watchOperations, { operations$ })
  yield fork(uploadSeasonJobsSaga)
  yield fork(watchReopenJobOperations)
  yield fork(setJobUrl)
}
